module.exports = __webpack_public_path__ + "static/media/law.b73d3a55.png";